import Vue from 'vue'
import { getDates } from './utils/helpers'

export default {
	namespaced: true,
	state: {
		allFinances: [],
		userBalance: 0,
		userName: null,
		date: getDates(),
		totalSum: {}
	},
	getters: {
		getInputFinance({ allFinances }) {
			return allFinances.filter(item => item.type == 'input')
		},
		getOutputFinance({ allFinances }) {
			return allFinances.filter(item => item.type == 'output')
		}
	},
	actions: {
		async fetchAll({ commit, state }) {
			const { start, end } = state.date
			let query = {
				date_start: start,
				date_end: end
			}
			let response = await Vue.http.get('personal-finance', { params: query })
			commit('setUserPersonalFinances', response.body)
			commit('set', { type: 'userName', value: null })
		},
		async addPay({ dispatch }, query) {
			await Vue.http.post('personal-finance', query)
			dispatch('fetchAll')
		},
		async storePay({ dispatch }, query) {
			await Vue.http.post('personal-finance/' + query.id, query.data)
			dispatch('fetchAll')
		},
		async deletePay({ dispatch }, payId) {
			await Vue.http.delete(`personal-finance/${payId}`)
			dispatch('fetchAll')
		},
		async addTransferPay({ dispatch }, query) {
			await Vue.http.post('user-transaction', query)
			dispatch('fetchAll')
		},
		async storeTransferPay({ dispatch }, query) {
			await Vue.http.post('user-transaction/' + query.id, query.data)
			dispatch('fetchAll')
		},
		async deleteTransferPay({ dispatch }, payId) {
			await Vue.http.delete('user-transaction/' + payId)
			dispatch('fetchAll')
		},
		async fetchUserFinanceAll({ commit, state }, userId) {
			const { start, end } = state.date
			let query = {
				date_start: start,
				date_end: end
			}
			let response = await Vue.http.get(`personal-finance/user/${userId}`, { params: query })
			commit('setUserPersonalFinances', response.body)
		}
	},
	mutations: {
		set(state, { type, value }) {
			state[type] = value
		},
		setUserPersonalFinances(state, response) {
			state.allFinances = response.finances
			state.userBalance = response.user.balance
			state.userName = response.user.name
			state.totalSum = {
				inputs: response.personal_sums.sum_inputs ? response.personal_sums.sum_inputs : 0,
				outputs: response.personal_sums.sum_outputs ? response.personal_sums.sum_outputs : 0,
				pays: response.sum_pays.pays ? response.sum_pays.pays : 0,
				debt: response.sum_pays.debt_pays ? response.sum_pays.debt_pays : 0,
				premium: response.sum_pays.premium_pays ? response.sum_pays.premium_pays : 0,
				accommodation: response.sum_pays.accommodation_pays ? response.sum_pays.accommodation_pays : 0,
				fare: response.sum_pays.fare_pays ? response.sum_pays.fare_pays : 0,
				zp: response.sum_pays.zp_pays ? response.sum_pays.zp_pays : 0,
			}
		}
	}
}
